import { Box, Grid, TextField } from "@mui/material";
import Button from "@mui/material/Button";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { apiClient, ADMIN_SERVER_BASE_URL } from "../util/apiClient";
import {
  addModeleRapport,
  IModeleRapport,
  updateModeleRapport,
} from "../store/modeleRapportSlice";
import { IReduxState } from "../store";
import LoadingButton from "@mui/lab/LoadingButton";
import SaveIcon from "@mui/icons-material/Save";
import { errorNotify, successNotify } from "../util/functions";

export interface IAddModeleProps {
  objetModele: IModeleRapport;
  libelleModeleRapport: string;
  setLibelleModeleRapport: any;
  setRenderModeleEditable: any;
  libelleModeleRapportToEdit: any;
  setLibelleModeleRapportToEdit: any;
}

export default function EditModele(props: any) {
  //props
  const {
    objetModele,
    libelleModeleRapport,
    setLibelleModeleRapport,
    libelleModeleRapportToEdit,
    setLibelleModeleRapportToEdit,
  } = props;

  //redux
  const dispatch = useDispatch();
  const { modelesRapport } = useSelector(
    (state: IReduxState) => state.modeleRapport
  );

  return (
    <div style={{ marginBottom: 10, backgroundColor: "#ECF0F3", padding: 20 }}>
      <Grid
        container
        spacing={2}
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
      >
        <Grid item md={12} xs={12} sm={12}>
          <TextField
            fullWidth
            multiline
            minRows={6}
            name="libelleModele"
            label="libellé"
            value={libelleModeleRapportToEdit}
            onChange={(e: any) => setLibelleModeleRapportToEdit(e.target.value)}
          />
        </Grid>
      </Grid>
    </div>
  );
}
